var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var InitialTitle = function (_a) {
    var nativeLeftTitleRef = _a.nativeLeftTitleRef, mainTitleText = _a.mainTitleText;
    return (_jsx("span", __assign({ className: "jobs__title__initial h-full w-full items-center justify-center lg:flex relative" }, { children: _jsx("p", __assign({ className: "lg:max-x-330px md:w-full text-left  font-normal leading-tight text-enblue-900 lg:w-1/2 lg:leading-normal", ref: nativeLeftTitleRef }, { children: mainTitleText }), void 0) }), void 0));
};
export default InitialTitle;
